<template>
  <hm-content title="">
    <div class="table-panel flex flex-end mb20">
      <el-select
        clearable
        size="small"
        class="mr10"
        filterable
        v-model="searchCondition.sourceType"
        placeholder="请选择申请来源"
      >
        <el-option label="禾苗后台" value="store"></el-option>
        <el-option label="禾苗小程序" value="smallProgram"></el-option>
      </el-select>
      <el-date-picker
        :default-time="['00:00:00', '23:59:59']"
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        start-placeholder="加入开始日期"
        end-placeholder="加入结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
      ></el-date-picker>
      <el-input
        clearable
        v-model.trim="searchCondition.keyword"
        placeholder="请输入公司名称/联系人/联系电话"
        size="small"
        style="width: 222px"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="brandTable"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="companyName"
          label="公司名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="customersPosition"
          label="职位"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="customersName"
          label="主要联系人"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="customersMobile"
          label="联系电话"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="customersMobile"
          label="邀请者"
          width="200"
        >
          <template slot-scope="scope">
            <span class="mr10">{{ scope.row.shareRecordName }}</span>
            {{ scope.row.shareRecordPhone }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sourceType"
          label="申请来源"
        >
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.sourceType === 'store'"
              >禾苗后台</span
            >
            <span class="success" v-else>禾苗小程序</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="申请时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="openAccountState"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              :class="scope.row.openAccountState === 'no' ? 'blue' : 'danger'"
              >{{
                scope.row.openAccountState === "no" ? "待开户" : "无效"
              }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.openAccountState === 'no'">
              <el-button size="small" type="text" @click="kaihu(scope.row)"
                >开户</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                size="small"
                type="text"
                class="orange"
                @click="invalid(scope.row)"
                >标记无效</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="开户"
      width="60%"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="供货商名称" prop="storeName">
          <el-input
            clearable
            v-model.trim="ruleForm.storeName"
            maxlength="20"
            size="small"
            placeholder="请输入供货商名称（20文本内）"
          ></el-input>
        </el-form-item>
        <el-form-item label="主要联系人" prop="contactName">
          <el-input
            clearable
            v-model.trim="ruleForm.contactName"
            maxlength="20"
            size="small"
            placeholder="请输入主要联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input
            clearable
            v-model.trim="ruleForm.contactPhone"
            maxlength="20"
            size="small"
            placeholder="请输入联系人电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="contactEmail">
          <el-input
            clearable
            v-model.trim="ruleForm.contactEmail"
            maxlength="20"
            size="small"
            placeholder="请输入邮箱号"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务费" prop="percentageMode">
          <!-- <el-radio-group v-model="ruleForm.percentageMode" size="small">
            <el-radio label="single">按单笔销售申报缴费</el-radio>
            <el-radio label="ratio">按提成发放比例缴费 </el-radio>
          </el-radio-group> -->
          <!-- <div v-if="ruleForm.percentageMode === 'single'">
            <el-input
              clearable
              v-model.trim="ruleForm.percentageMoney"
              maxlength="20"
              size="small"
              @input="filterGt0OrFixed2('percentageMoney')"
              placeholder="请输入"
            ></el-input>
          </div> -->
          <div>
            <el-input
              clearable
              v-model.trim="ruleForm.percentageRatio"
              maxlength="20"
              @input="filterGt0OrFixed2('percentageRatio')"
              size="small"
              placeholder="请输入服务费比例"
            ></el-input
            >%,最低服务费<el-input
              clearable
              v-model.trim="ruleForm.nadirMoney"
              maxlength="20"
              @input="filterGt0OrFixed2('nadirMoney')"
              size="small"
              placeholder="请输入最低服务费"
            ></el-input
            >元
          </div>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="标记无效"
      :close-on-click-modal="false"
      :visible.sync="invalidDialogVisible"
      width="500px"
    >
      <div>
        <div class="flex flex-center">
          <div class="text-center">
            <span
              style="font-size: 50px"
              class="hmicon icon-tishi orange"
            ></span>
          </div>
        </div>
        <div class="text-center mt10 orange" style="font-size: 20px">
          是否将信息标记为无效信息？
        </div>
        <div class="text-center mt10" v-if="row.shareRecordPhone">
          <el-checkbox v-model="checked">同时将提供者加入黑名单</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button
          size="small"
          type="info"
          @click="invalidDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    const validatorFunc = function(rule, val, callback) {
      if (this.ruleForm.percentageRatio === "") {
        return callback(new Error("请输入服务费比例"));
      } else {
        if (this.ruleForm.percentageRatio > 100) {
          return callback(new Error("缴费比例不能超过100%"));
        }
      }
      if (this.ruleForm.nadirMoney === "") {
        return callback(new Error("请输入最低服务费"));
      }

      callback();
    }.bind(this);
    return {
      checked: false,
      invalidDialogVisible: false,
      searchCondition: {},
      ruleForm: {
        storeName: "",
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        nadirMoney: "",
        percentageRatio: ""
      },
      rules: {
        storeName: [
          {
            required: true,
            min: 2,
            max: 20,
            message: "名称应大于2小于20个字",
            trigger: "blur"
          }
        ],
        contactName: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur"
          }
        ],
        contactPhone: [
          {
            required: true,
            message: "请输入联系人电话",
            trigger: "blur"
          }
        ],
        contactEmail: [
          {
            required: true,
            message: "请输入邮箱号",
            trigger: "blur"
          }
        ],
        percentageMode: [
          // {
          //   required: true,
          //   message: "请选择缴费方式",
          //   trigger: "blur"
          // },
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          }
        ]
      },
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      dialogVisible: false,
      row: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async save() {
      let params = {
        potentialCustomersId: this.row.potentialCustomersId,
        joinTheBlacklist: this.checked ? "yes" : "no",
        shareRecordPhone: this.row.shareRecordPhone
      };
      const { code } = await this.$store.dispatch("updateInvalid", params);
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.queryList();
        this.invalidDialogVisible = false;
        this.checked = false;
      }
    },
    invalid(row) {
      this.row = row;
      this.invalidDialogVisible = true;
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        auditState: this.auditState === "all" ? "" : this.auditState
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.createStartTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.createEndTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryCustomersInfoList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    kaihu(row) {
      if (row.sourceType === "smallProgram") {
        this.row = row;
        this.ruleForm.storeName = row.companyName;
        this.ruleForm.contactPhone = row.customersMobile;
        this.ruleForm.contactName = row.customersName;
        this.dialogVisible = true;
      } else if (row.sourceType === "store") {
        window.open(
          `https://platform.hemiao100.com/merchantManagement/addManager?id=${row.potentialCustomersId}&contactName=${row.customersName}&storeName=${row.companyName}&contactPhone=${row.customersMobile}`
        );
      }
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async confirm(formName) {
      const valid = await this.$refs[formName].validate();

      if (valid) {
        let params = this.ruleForm;
        Object.assign(params, this.row);
        params.percentageMode = "ratio";
        this.$store.dispatch("saveSupplierBasicInfo", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
            this.dialogVisible = false;
            this.queryList();
          }
        });
      } else {
        return false;
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
